import type { ImageProps } from "~www/types/sanity-image";

import Image from "next/image";
import { getAssetProps } from "~www/lib/images/sanity-image-utils";

export function SanityImage({
  asset,
  alt,
  width,
  height,
  className,
  quality = 75,
  fill,
  ...imageProps
}: ImageProps) {
  if (!asset?.asset) {
    return null;
  }

  const { url, imageWidth, imageHeight } = getAssetProps({
    asset,
    height,
    quality,
    width,
  });

  // if fill is true, set fill, otherwise set width/height
  const sizeProps = fill
    ? { fill }
    : { height: imageHeight, width: imageWidth };

  return (
    <Image
      alt={alt ?? ""}
      // RE: aria-label: in the future we can provide optional additional descriptive information
      // via the schema, but it's not useful to screen reader users if it's the same as alt
      className={className}
      src={url}
      {...imageProps}
      {...sizeProps}
    />
  );
}
